import { TagsDocument } from '~~/graphql/operations'
import { BaseSelect } from '../model'

export class TagSelect extends BaseSelect {
  override name = 'tagId'
  override label = 'Tag'
  override placeholder = 'Select tags'

  override options(query: string, where) {
    return this.optionsQuery(TagsDocument, 'tags', {
      variables: {
        where: {
          ...where,
          tagTexts: query ? {
            some: {
              name: {
                contains: query,
              },
            },
          } : undefined,
        },
      },
    })
  }

  override async initialOptions(ids: any[], where) {
    const options = await this.optionsQuery(TagsDocument, 'tags', {
      variables: {
        where: {
          ...where,
          id: ids?.length ? { in: ids.map(Number) } : undefined,
        },
      },
    })
    return options
  }
}
